import {format, parse} from 'date-fns';

import {E_FORMAT_DATE} from '@/constants/DatesConstants';

export const formatAppDate = (
  date: string | Date,
  dateFormat: string = E_FORMAT_DATE.MMMM_dd_yyyy,
) => {
  if (!date) return '';

  try {
    let parsedDate: Date;

    if (typeof date === 'string') {
      parsedDate = parse(date, E_FORMAT_DATE.yyy_MM_dd, new Date());
    } else {
      parsedDate = date;
    }

    const formatted = format(parsedDate, dateFormat);
    return formatted;
  } catch (error) {
    console.warn('Error formatting date', date, 'using format', dateFormat);
    return '';
  }
};
